export default __webpack_public_path__ + "static/media/githubsamlguide.e62b86c7.png";